"use client"

export const BEGIN_CHECKOUT_SESSION_STORAGE_KEY = "ga4_begin_checkout_basket_key"

export function resetBeginCheckoutAttempt() {
  if (typeof window === "undefined") return
  try {
    window.sessionStorage.removeItem(BEGIN_CHECKOUT_SESSION_STORAGE_KEY)
  } catch {
    // Optional tracking guard only.
  }
}

export function isCheckoutAddressesHref(href: string | undefined) {
  return !!href && href.includes("/basket/checkout/addresses")
}
